import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaginatedVideos } from "../../features/pagination/paginationSlice";
import Number from "./Number";

export default function Pagination() {
    const { tags, search, author } = useSelector((state) => state.filter);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchPaginatedVideos({ tags, search, author }));
    }, [dispatch]);

    const { videos } = useSelector(state => state.pagination);
    const numberOfVideo = parseInt(videos.length / 4 + 1);

 


    return (
        <section className="pt-12">
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">

                {videos.map((video, index) => index < numberOfVideo && (<Number key={index} index={index+1} />))}

            </div>
        </section>
    );
}

